import {
    FunctionarySwitch,
    Switch,
    SwitchFilter,
    SwitchHistorical,
} from '../shared/types/modules/switch';
import { apiService } from './index';

export const asyncGetSwitchs = async (
    filters: SwitchFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: Switch[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: Switch[]; length: number };
        } = await apiService.get('/api/switch', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetSwitch = async (
    idSwitch: string
): Promise<Switch | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Switch;
        } = await apiService.get(`/api/switch/${idSwitch}`);

        return data;
    } catch (error) {}
};

export const asyncCreateSwitch = async (
    info: Switch,
    dataFS: FunctionarySwitch
): Promise<Switch | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Switch;
        } = await apiService.post('/api/switch', { ...info, ...dataFS });

        return data;
    } catch (error) {}
};

export const asyncUpdateSwitch = async (
    id: string,
    info: Switch,
    dataFS: FunctionarySwitch
): Promise<Switch | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Switch;
        } = await apiService.patch(`/api/switch/${id}`, { ...info, ...dataFS });

        return data;
    } catch (error) {}
};

export const asyncGetSwitchHistorical = async (
    idInitialCasuality: string
): Promise<SwitchHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: SwitchHistorical[];
        } = await apiService.get(
            `/api/switch/${idInitialCasuality}/historical`
        );

        return data;
    } catch (error) {}
};
